import { render, staticRenderFns } from "./options.vue?vue&type=template&id=d5ce8fa4&"
import script from "./options.vue?vue&type=script&lang=js&"
export * from "./options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ce8fa4')) {
      api.createRecord('d5ce8fa4', component.options)
    } else {
      api.reload('d5ce8fa4', component.options)
    }
    module.hot.accept("./options.vue?vue&type=template&id=d5ce8fa4&", function () {
      api.rerender('d5ce8fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/options.vue"
export default component.exports